

/**
 * TODO:
 * - this should be a form
 * - really need to refactor to be a LayoutView at least ( may not be huge refactor; would have to test all note types )
 * - move referral stuff to drawable note (or page note); leaving in here for now as likely will be added to all note types
 *    and would be more appropriate when create views for all the diff note types, which is a larger project
 *
 */

require('./note.less');
require('./activityNote.less'); //TODO: separate when own class; some classing already in progress
require('./note-icons.less');

var Marionette = require('marionette'),
    _ = require('underscore'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV'),
    SpinView = require('../../../common/spinView'),
    Util = require('../../../FV/util'),
    ConsultGroupSelector = require('./consultGroupSelector/view'),
    AccessGroupSelector = require('./accessGroupSelector/view'),
    getContrastYIQ = Util.getContrastYIQ; // inc perf somewhat


require('extendMoment');
require('extendJQuery'); // (setCursorEndOfText)
require('backbone.mousetrap');
require('jqHighlight');
require('autosize');



module.exports = Marionette.ItemView.extend({
    className: 'note',
    template: require('./note.hbs'),
    initialize: function(options) {

        _.extend( this, _.pick(options, 'model', 'channel'), {
            uiModel: options.model.uiModel,
            consultSelectorView: null,
            accessGroupSelectorView: null
        });

         _.bindAll(this,'_getRawUserInput');
    },

    onRender: function() {

        this.unwrap();

        // showNoteOperations: isPageNote or newFlashNote (that's not a flashback note) ... TODO: can have different condition on FlashNote View
        if ( this.ui.accessGrpPlaceHolder.length > 0 )
            this._createAccessGroupSelectorView();

        if ( this.model.showConsultGroupSelectorOnNoteViews() )
            this._createConsultSelectorView();


    },

    _createConsultSelectorView: function() {

        this.consultSelectorView = new ConsultGroupSelector({

            userConsultGroups: fvChannel.request('user').getReferralGroups(),
            note: this.model,
            onChange: function() {
                this.channel.trigger( 'consultSelectView:groupsChanged', this.model );
            }.bind( this )

        });

        this.ui.consultSelectPlaceholder.replaceWith( this.consultSelectorView.render().el );

    },

    // TODO: reorg the whole flashback process when have time; it's not understandable
    // -- this was combined with the 'recipient of flash notes'
    // -- split up but not it's tied on the save process ... maybe create a subview
    // Note: it's no longer written for flash back notes
    _createAccessGroupSelectorView: function() {

        var user = fvChannel.request('user'),
            note = this.model;

        var groups = note.isFlashNote() && note.isNew()
            ? user.privateGroups.getIdDescs() // don't print for flash-back notes -- no need
            : user.groups.getArrayOfModelAttrsSortedByName();

        // TODO: temp fix for FLASH NOTE printing desc's instead of names --> gotta be clearer way
        // perhaps just create another view for the flashnote select ...

        if ( note.isFlashNote() ) {
            groups = _.map( groups, function(g) {
                return {
                    groupId: g.groupId,
                    name: g.description // print description as name
                };
            });
        }

        this.accessGroupSelectorView = new AccessGroupSelector({
            groups: groups,
            onChange: _.bind( this.onAccessGroupChange, this) , // picked up by the flashNoteView
            selectedGroupId: this.model.get('accessGroup') // Must have been the same for flash notes
        });

        this.ui.accessGrpPlaceHolder.replaceWith( this.accessGroupSelectorView.render().el );

    },

    onAccessGroupChange: $.noop,

    // Hack: pass down the on show method to the child view;
    // See notes for refactor here in graphic stamp selector:
    // Should really make this view a Marionette region / Babysitter View
    onShow: function() {

        this.consultSelectorView &&
            this.consultSelectorView.triggerMethod('show');

        this.accessGroupSelectorView &&
            this.accessGroupSelectorView.triggerMethod('show');

    },
    /**
     * request, notes:noteSaveFailure -- essentially act the same as $.ajax success and error callbacks/events,
     * used to show/hide the loading spinner during ajax calls.
     * request: Backbone.Model.save invokes when $.ajax request made to server
     * notes:noteSaveFailure: differentiate from Backbone.sync's 'error' event to more clearly accomodate current note save workflow
     * ( captureed top-down in options.error cb )
     * Eventually we should change the note saving workflow to utilize a deferred from the call to model.save.
     * Note: post a successful save all note views are re-rendered (so the spinner is inherently destroyed )
     * invalid: will trigger for both invalid attributes prior to a request and on those returned from the server.
     */
    modelEvents: {
        'request':                  'showSpinIndicator',
        'notes:noteSaveFailure':    'destroySpinner',
        'invalid':                  'validationError',
        'showSavedIndicator':       'showSavedIndicator'
    },
    uiModelEvents: {
        'change:editMode':      'toggleEditMode',
        'change:expanded':      'toggleExpandMode',
        'change:isEditable':    'toggleModButtons'
    },
    ui: {
        bodyField:                  '.noteBody',
        textArea:                   '.taNoteBody',
        noteSubject:                '.subj-input',
        subjectDiv:                 '.subj-div',
        autoDisplay:                '.autoDisplay',
        okBtn:                      '.ok',
        cancelBtn:                  '.cancel',
        editBtn:                    '.edit',
        moreBtn:                    '.ellipsis-wr',
        deleteBtn:                  '.delete',
        noteHeader:                 '.noteHead',
        submitRow:                  '.submit-row',
        validationErr:              '.validation-err',
        iconWrapper:                '.note-icon-wr',
        accessGrpPlaceHolder:       '[data-access-grp-select-holder]',
        consultSelectPlaceholder:   '[data-consult-select-holder]',
        consultGrpLbls:             '.consult-grp-label'
    },
    /* note: these forwarded to notes local channel */
    triggers: {
        'click @ui.okBtn'       :   'enterSave',
        'click @ui.cancelBtn'   :   'enterCancel',
        'click @ui.editBtn'     :   'enterEdit',
        'click @ui.moreBtn'     :   'enterExpand',
        'click @ui.deleteBtn'   :   'enterDelete',
        'mouseenter'            :   'enterMouseHover',
        'mouseleave'            :   'exitMouseHover'
    },
    keyboardEvents: {
        'shift+enter':  function(e) {

            e.preventDefault();  //necessary to prevent dupe post from keydown
            e.stopImmediatePropagation();  //for the return key (can be called twice)
            this.trigger('enterSave');

        },
        'esc': 'escapeKey'
    },
    escapeKey: function() {

        //filter b/f trigger : latter is for openedFlashNotes
        if (  !this.options.channel.request('noteIsActiveNote', this.model) || this.model.FN_WAS_OPENED )
            return false;

        this.trigger('enterCancel');

    },

    //TODO: keep fixing up
    serializeData: function() {

        var m = this.model,
            vc = this.options.channel.request('vChannel'),
            user = fvChannel.request('user'),
            creating = m.isNew(),
            noteType = m.get('noteType'),
            ctime  = m.get('creationTime')
                ? m.get('creationTime')
                : moment(),
            isFlashNote = noteType === 'FLASH_NOTE',
            isPageNote = !m.isDocument,
            isTextNote = m.isTextNote(), //(doc / pg)

            isFDDGraphicNote = m.isFDDGraphicNote(),
            supportConsults = m.showConsultGroupSelectorOnNoteViews();

            return {
                viewerChannel: vc, // pass in case needed used in template helpers
                note: m,
                user: user,
                noteType: noteType,
                iconClass: m.iconClass ? m.iconClass : '',
                pgNum: m.pageNumber,
                newNoteTextAreaPlaceHolder: 'Enter text note',
                iconHoverLabel: m.getIconHoverLbl(),
                isTextNote: isTextNote,
                ctime: creating
                    ? ''
                    : moment.convertDBTimeToLocalTime(ctime),
                cuser: m.get('creationUserDesc'),
                textNoteValue: m.isDocument || m.isPageTextNote()
                    ? m.get('text') 
                    : '', 
                pgNavigationDisabled: vc ? false : true, //(exists with viewer)

                hideAutoDisplay: !m.autoDisplayApplies, // Note: only applies to page notes; hide the auto-display row from the UI -- fix when subclass
                display: m.autoDisplayNote(), //sets the checkbox for whether to apply auto-display (if it applies)

                isPageNote: isPageNote,
                isNew: creating,
                isFlashNote: isFlashNote,
                noteClass: m.getNoteClass(),
                isActivityNote: m.isActivityNote(),
                filterOut: this.uiModel.isFiltered(),
                isFDDGraphicNote: isFDDGraphicNote,
                showConsultInput: supportConsults,
                showConsultRow: supportConsults && m.consultGroupsAssigned(),
                userCanModifyOrDeleteNotes: vc.request('allowModifyOrDeleteNote')

            };
    },


    //could use state here to say render this / that (eg new, eg editing )
    templateHelpers: { //context is the serializedData if literal

        subject: function() {
            return this.isNew ? '' : this.note.getSubject();
        },
        subjectPH: function() {
            return this.note.desc;
        },
        includeActionBtns: function() {
            return !this.isActivityNote ;
        },
        includeModBtns: function() {
            return !this.isActivityNote;
        },
        includeSubjectLabel: function() {
            return !this.note.isTextNote() && !this.isFlashNote && !this.isActivityNote;
        },
        noteInputFieldIsTextArea: function() {
            //DVBC-1321 -- now show text, not subject for activity notes
            return this.note.isTextNote() || this.isFlashNote || this.isActivityNote;
        },
        includePgNumber: function() {
            return !this.note.isDocument;
        },
        showMoreBtn: function() {
           return this.note.isDrawable();
        },
        includeEditBtn: function() {

            // First check perm ( apply to doc and page notes )
            if ( !this.userCanModifyOrDeleteNotes )
                return false;

            if ( this.note.isDocument )
                return true;

            // Page: if drawable, can't be creatable on undrawable pages, no check needed
            if ( this.note.isSignature() || this.isFDDGraphicNote )
                return false;

            return true;

        },
        includeDeleteBtn: function() {

            return this.userCanModifyOrDeleteNotes;

        },
        showNoteOperations: function() {
            return this.isPageNote || (this.isFlashNote && this.isNew);
        },
        consultGroups: function() {

            return _.map( this.note.getConsultGroups(), function(cg) {

                var colorDefined = cg.color !== null,
                    labelColor = colorDefined ? cg.color : 'transparent';

                return  {
                    name: cg.name,
                    labelColor: labelColor,
                    textColor:  colorDefined ? getContrastYIQ(labelColor, '#333') : 'inherit'
                };

            });
        }

    },

    showSpinIndicator: function() {

        this.ui.okBtn.find('i').addClass('invisible');

        this.spinner = new SpinView({
            color: 'white',
            length: 3,
            radius: 3
        });

        this.ui.okBtn.append( this.spinner.render().el );

        this.spinner.$el.css('top', '-6px');

    },
    toggleEditMode: function(uiModel, editMode, options) { // '(opens it up)

        this.setElement(this.el); //unsure what this was for ... prob calling delegate events; not changing in case breaks

        if ( editMode )  {//opening
            this.$el.addClass('edit-mode');
            this._postBaseToggleEditMode( true );
            this.bindKeyboardEvents(); //(in delegate, turned off by default)
        }  else {    //closing -- looks same in edit/new --- *** POST SAVE ACTIONS */
            this.unbindKeyboardEvents();
            this.ui.textArea.addClass('hide').blur().trigger('autosize.destroy'); //destroy plugins on close, not on view destruction: (needs to be called again anyway upon reopen)

            //( TODO: move up -- post toggle edit mode call)
            // Now trigger an event from the model to facilitate this in find and redact,
            // rather than a function call, vs called fn directly on the view.
            (options && options.noteSaved) &&
                this.model.trigger('showSavedIndicator');

            this._postBaseToggleEditMode( false );
        }

    },
    // Apply plugin after visible (also whenever text content changes)
    _postBaseToggleEditMode: function(isEntering) {
        isEntering && this.ui.textArea.removeClass('hide').setCursorEndOfText().autosize();
    },

    /* state: expanded */
    toggleExpandMode: function(uiModel, expanded) {

        //TODO: clean up -- combo's style with edit-mode css as well
        //TODO: this should also be a re-render for clarity

        var $inputs = this.$('input, select');

        if (expanded) {
            this.ui.moreBtn.attr('title', 'Less');
            $inputs.attr('disabled', 'disabled').trigger('chosen:updated');
            this.$el.addClass('expanded');
        } else {
            this.ui.moreBtn.attr('title', 'More');
            $inputs.removeAttr('disabled').trigger('chosen:updated');
            this.$el.removeClass('expanded');
        }
    },

    toggleModButtons: function(uiModel, allowEdit) {
        this.$el.toggleClass('notEditable', !allowEdit);
    },


    toggleFiltered: function(noteFilterModel) {

        if ( noteFilterModel.isSourceSAT() )
            this._highlightDomForSATFilterToggle( noteFilterModel.getSatTxt() );

        this.$el.toggleClass( 'hide', this.uiModel.isFiltered() );

    },
    _highlightDomForSATFilterToggle: function(satFilterTxt) {

        this.$el.unhighlight(); //put data attr / class on what is filterable?
        this.$el.highlight(satFilterTxt);
        /*
            - sat is only done when not in expanded/edit mode, so if want to highlight
              anything visible in that mode, would need to filter down the selectors to only those used (eg not labels)
            - could switch to diff plugin that allows to skips elements (marked) / fork jq highlight
            - below is quick hack to not highlight the referred to label ... if have more like this in future impl more robust solution
         */
        this.ui.consultGrpLbls.unhighlight();

    },

    showSavedIndicator: function() {

        var $el = this.$el.addClass('postSave'),
           self = this;

        setTimeout( function() {
            $el.removeClass('postSave');
            self.triggerMethod('saveIndicatorComplete'); // I think for flashnote only ...
        }, 3000);

    },
    // get the attributes in the ui that were changed by the user necessary for persistence (for use in model fn)
    // later sanitized by a fn in the note model, and, in some cases, altered into a different obj expected by save webservice
    // TODO: stop this and store on model on change already ...
    _getRawUserInput: function() {

        var accessibleByPrinted = this.accessGroupSelectorView;

        var input = {
            noteSubject: this.ui.noteSubject.val(),  //looks like always captured
            text: this.ui.textArea.val(),  //looks like always captured

            autoDisplayChecked: this.ui.autoDisplay.is(':checked'), //looks like always captured

            // note: accessible by not printed for doc ( but it's a part of the data structure)
            // -- will not have changed
            // TODO:
            // - ever need to pass the name????
            // - test saving
            // - need to pass for doc notes ( not flash notes )

            // i guess its the parent for flashbacks
            accessibleByName: accessibleByPrinted
                ?  this.accessGroupSelectorView.getSelectedGroup().groupName // was:  this.ui.accessibleBy.find(':selected').text() // flash note could be group description ...
                :  this.model.get('accessGroupName'),   // (not printed for doc) -- not really necessary b/c of sanitize fn

            accessibleByVal: accessibleByPrinted
                ?  this.accessGroupSelectorView.getSelectedGroup().groupId // i guess the parent for flash back
                :  this.model.get('accessGroup')  //(not printed for doc)
        };


        if (this.consultSelectorView) {
            // store on consult groups obj in WF to pass on b/f saving -- will be put on compound obj
            input['consultGroups'] = this.consultSelectorView.getSelectedGroups(); // (an array of attributes to save)
        }

        return input;

    },

    validationError: function(note, errObj) {
        this.ui.validationErr.text( errObj.message );
    },
    //TODO: clean and combo with show/create
    destroySpinner: function() {
        this.spinner.destroy();
        this.ui.okBtn.find('i').removeClass('invisible');
    },

    //TODO: THOUGH W/OUT, MEM LEAK -- but with events not set on render
    undelegateEvents: function() {
        Marionette.View.prototype.undelegateEvents.call(this);
        this.unbindEntityEvents(this.uiModel, this.uiModelEvents); //-- undelegating stops workflow from working, um model no longer listened to?
        this.unbindUIElements();
        this.stopListening();
        return this;
    },
    delegateEvents: function() {
        Marionette.View.prototype.delegateEvents.call(this);  //clears uimodel events if comes after -- MUST DO BEFORE
        this.bindEntityEvents(this.uiModel, this.uiModelEvents);
        this.bindUIElements();
        //(*Only want to listen if the active note -- the default is off)
        this.unbindKeyboardEvents();
        return this;
    },
    onBeforeDestroy: function() {

        this.ui.textArea.trigger('autosize.destroy');

        // child views ...
        this.consultSelectorView && this.consultSelectorView.destroy();
        this.accessGroupSelectorView && this.accessGroupSelectorView.destroy();

    },
    destroy: function() {

        Marionette.ItemView.prototype.destroy.apply(this, arguments);
        /* ensure clear of jq cache */
        this.$('*').remove();
        this.unbindUIElements();
        this.$el.remove();
        // pretty good but still tiny mem leak

    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/note.js
 ** module id = 155
 ** module chunks = 0
 **/